import React from 'react';
import type { HomeDashboard } from '../../../api/homeV3Api';
import { formatDate } from '../utils/formatters';
import styles from '../HomeV3.module.css';

interface Props {
    dashboard: HomeDashboard;
    isFetching: boolean;
    onRefresh: () => void;
}

export function DashboardHeader({ dashboard, isFetching, onRefresh }: Props) {
    return (
        <header className={styles.header}>
            <div className={styles.headerTitleGroup}>
                <h1 id="home-dashboard-title" className={styles.title}>Home dashboard</h1>
                <p className={styles.subtitle}>
                    <strong>{dashboard.user.displayName}</strong>
                </p>
            </div>
            <div className={styles.refreshGroup}>
                <span className={styles.muted}>Updated {formatDate(dashboard.generatedAtUtc, true)}</span>
                <button className={styles.secondaryButton} type="button" onClick={onRefresh} disabled={isFetching}>
                    {isFetching ? 'Refreshing…' : 'Refresh'}
                </button>
            </div>
        </header>
    );
}
